import { Component, OnInit } from '@angular/core';
import { TelecomService } from 'src/app/services/telecom/telecom.service';
import { environment } from 'src/environments/environment';
import { Guid } from 'guid-typescript';
import { LobLandingComponent } from '../lob-landing/lob-landing.component';

@Component({
  selector: 'app-ccp-configuration',
  templateUrl: './ccp-configuration.component.html',
  styleUrls: ['./ccp-configuration.component.css']
})
export class CcpConfigurationComponent implements OnInit {

  lobList: Array<any> = [];
  lobSelect: string = "";
  lambdaError: boolean = false;
  lambdaMessage: string = '';
  formValid: boolean = false;
  flagFormValid: boolean = false;
  flagBluePrint = {name:""}
  bluePrint = {featureName: "", active: null, id: this.newGUID()}
  flags: Array<any> = [];


  data: Array<any> = [];

  constructor(private telecomService: TelecomService) { }

  async ngOnInit() {
    this.getLOBs();
    let config = await this.getConfig();
    this.data = config.flagData;
    this.flags = config.flagNames;

    console.debug(this.data);
  }

  getLOBs(){
    this.telecomService.getLOBs().then((resultData:any)=>{
      console.log("get lob result: ", resultData);
      this.lobList = resultData.lobList
      // Add any missing LOBs
      for(let lob in this.lobList ){
        let lobName = this.lobList[lob][1];
        if(!this.data[lobName]){
          this.data[lobName] = [];
        }
      }
    });
  }


  async getConfig(){
    let config = await this.telecomService.getRows(environment.CcpConfigLambdaName).then((data: any) => {
      if(data.statusCode == 200){
        //Get data put into table variable
        let flagData = JSON.parse(data.body).ccpConfig;
        let flagNames = JSON.parse(data.body).flags;
        console.debug(data);
        return { flagData, flagNames }
      }
      else{
        console.error(data.Error);
      }
    });
    return config;
  }

  handleButtonEvent(evt: any){
    console.log(evt);
  }

  handleNewItem(evt: any){
    console.log(evt);
    //This needs to change, since the item in this case is
    if(evt.button == "create"){
      console.log("Creating a row...")
      return
    }
    if(evt.button == "delete"){
      if(this.lobSelect){
        this.data[this.lobSelect] = this.data[this.lobSelect].filter(item => {return !(item.featureName == evt.item.featureName)})
      }
      this.flags = this.flags.filter(item => {return !(item.name == evt.item.name)});
    }
    let item = {
      action: "put",
      item: {
          lastUpdated: "",
          collectionName: "ccpConfig",
          Key: "0",
          data: this.data,
          flags: this.flags
      }
    }
    this.telecomService.saveRow(item, environment.CcpConfigLambdaName).then((data: any) => {
      if(data.statusCode == 200){
        //Get data put into table variable
        this.data = JSON.parse(data.body).ccpConfig.data;
        this.flags = JSON.parse(data.body).ccpConfig.flags;
        console.info(data);
        this.lambdaError = false;
        this.lambdaMessage = "Data updated successfully.";
      }
      else{
        console.error(data.Error);
        if(evt.action == "put"){
          this.lambdaMessage = "An error occurred, data was not saved successfully.";
        }
        else if(evt.button == "delete"){
          this.lambdaMessage = "An error occurred, data was not deleted successfully.";
        }
      }
    });
  }

  validate(item){
    this.formValid = false;
    this.lambdaMessage = '';
    if(!item.featureName){
      this.lambdaMessage = 'flag name is required.';
      this.lambdaError = true;
      return;
    }
    // for(let lobFlag in this.data[this.lobSelect]){
    //   console.debug(lobFlag);
    //   if (this.data[this.lobSelect][lobFlag].featureName == item.featureName){
    //     this.lambdaMessage = 'The flag name must be unique.';
    //     this.lambdaError = true;
    //     return;
    //   }
    // }
    if(!item.active){
      this.lambdaMessage = 'The flag must be set.';
      this.lambdaError = true;
      return;
    }
    this.formValid = true;
  }

  validateFlag(item){
    this.flagFormValid = false;
    this.lambdaMessage = '';
    if(!item.name){
      this.lambdaMessage = 'flag name is required.';
      this.lambdaError = true;
      return;
    }
    if(!item.description){
      this.lambdaMessage = 'description is required.';
      this.lambdaError = true;
      return;
    }
    this.flagFormValid = true;
  }

  isFlagInUse(flag){
    for(let lobFlag in this.data[this.lobSelect]){
      if (this.data[this.lobSelect][lobFlag].featureName == flag.name){
        return true;
      }
    }
    return false;
  }

  newGUID(){
    return Guid.create()['value'];
  }
}